import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const EducationDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Education Level"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Education Level">
                {getFieldDecorator('education', {
                 initialValue: data.education,
                  rules: [{ required: true, message: 'Please input the Education Level!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default EducationDialogForm;
